<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
    <!-- Navbar brand -->
    <ul class="nav navbar-nav flex-row">
        <li class="nav-item">
            <a class="navbar-brand" [routerLink]="['/']">
                <span class="brand-logo">
                    <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
                </span>
                <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
            </a>
        </li>
    </ul>
    <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">
    <div class="bookmark-wrapper d-flex align-items-center">
        <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
        <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
            <li class="nav-item">
                <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
                    <span [data-feather]="'menu'" [class]="'ficon'"></span>
                </a>
            </li>
        </ul>
        <!--/ Menu Toggler -->

        <!-- Toggle skin -->
        <li class="nav-item d-none d-lg-inline-flex">
            <a class="nav-link nav-link-style btn" placement="bottom" ngbTooltip="{{ currentSkin === 'dark' ? 'Világos mód' : 'Sötét mód' }}" (click)="toggleDarkSkin()">
                <span [ngClass]="currentSkin === 'dark' ? 'icon-sun' : 'icon-moon'" class="ficon font-medium-5 feather"></span>
            </a>
        </li>
        <!--/ Toggle skin -->

        <!-- Naptár -->
        <li class="nav-item d-none d-lg-inline-flex" *ngIf="!currentUser?.munkatars">
            <a class="nav-link nav-link-style btn" placement="bottom" ngbTooltip="Naptár" [routerLink]="['/', 'torzsek', 'naptar']">
                <span class="ficon font-medium-5 feather" [data-feather]="'calendar'"></span>
            </a>
        </li>
        <!--/ Naptár -->

        <!-- Szabadság naptár -->
        <li class="nav-item d-none d-lg-inline-flex" *ngIf="!currentUser?.munkatars && (currentUser?.felhasznaloi_csoport?.id == 27 || currentUser?.felhasznaloi_csoport?.id == 28 || currentUser?.felhasznaloi_csoport?.id == 2 || currentUser?.felhasznaloi_csoport?.id == 4 || currentUser?.felhasznaloi_csoport?.id == 30)">
            <a class="nav-link nav-link-style btn" placement="bottom" ngbTooltip="Szabadságok" [routerLink]="['/', 'torzsek', 'szabadsag-naptar-erp']">
                <span class="ficon font-medium-5 feather" [data-feather]="'github'"></span>
            </a>
        </li>
        <!--/ Szabadság naptár -->

        <!-- Szabadság naptár -->
        <li class="nav-item d-none d-inline-flex" *ngIf="currentUser?.munkatars">
            <a class="nav-link nav-link-style btn" placement="bottom" ngbTooltip="Szabadság naptár" [routerLink]="['/', 'torzsek', 'szabadsag-naptar']">
                <span class="ficon font-medium-5 feather" [data-feather]="'calendar'"></span>
            </a>
        </li>
        <!--/ Szabadság naptár -->

        <!-- Munkatárs dokumentumok -->
        <li class="nav-item d-none d-inline-flex" *ngIf="currentUser?.munkatars">
            <a class="nav-link nav-link-style btn" placement="bottom" ngbTooltip="Dokumentumok" [routerLink]="['/', 'torzsek', 'munkatars-dokumentumok']">
                <span class="ficon font-medium-5 feather" [data-feather]="'file-text'"></span>
            </a>
        </li>
        <!--/ Munkatárs dokumentumok -->

        <!-- Munkatárs jelenléti nyomtatása -->
        <li class="nav-item d-none d-inline-flex" *ngIf="currentUser?.munkatars && route == 'szabadsag-naptar'">
            <button class="nav-link nav-link-style btn" type="button" placement="bottom" ngbTooltip="Jelenléti ív nyomtatása" (click)="onJelenletiPrint()">
                <span class="ficon font-medium-5 feather" [data-feather]="'printer'"></span>
            </button>
        </li>
        <!--/ Munkatárs dokumentumok -->

        <!-- Munkatárs jelenléti feltöltése -->
        <li class="nav-item d-none d-inline-flex" *ngIf="currentUser?.munkatars">
            <a class="nav-link nav-link-style btn" placement="bottom" ngbTooltip="Jelenléti ív feltöltése" (click)="openUploadJelenleti(fajlfeltoltesModal)">
                <span class="ficon font-medium-5 feather" [data-feather]="'upload'"></span>
            </a>
        </li>
        <!--/ Munkatárs jelenléti feltöltése -->

        <!-- Beosztások -->
        <li class="nav-item d-none d-lg-inline-flex" *ngIf="!currentUser?.munkatars && (currentUser?.felhasznaloi_csoport?.id == 27 || currentUser?.felhasznaloi_csoport?.id == 28 || currentUser?.felhasznaloi_csoport?.id == 2 || currentUser?.felhasznaloi_csoport?.id == 4)">
            <a class="nav-link nav-link-style btn" placement="bottom" ngbTooltip="Beosztások kezelése" [routerLink]="['/', 'torzsek', 'beosztas-kezeles']">
                <span class="ficon font-medium-5 feather" [data-feather]="'layout'"></span>
            </a>
        </li>
        <!--/ Beosztások -->

        <!-- Feladatok -->
        <li class="nav-item d-none d-lg-inline-flex" *ngIf="!currentUser?.munkatars">
            <a class="nav-link nav-link-style btn" placement="bottom" ngbTooltip="Feladatok" [routerLink]="['/', 'torzsek', 'feladatok']" style="position:relative">
                <span class="ficon font-medium-5 feather" [data-feather]="'check-square'"></span>
                <span *ngIf="olvasatlan > 0" class="badge badge-pill badge-danger badge-up" style="top: -5px !important;
                right: -5px !important;
                min-width: 1.129rem !important;
                min-height: 1.129rem !important;">{{ olvasatlan }}</span>
            </a>
        </li>
        <!--/ Feladatok -->


        <!-- Beállítások -->
        <li class="nav-item d-none d-lg-inline-flex" *ngIf="!currentUser?.munkatars">
            <a class="nav-link nav-link-style btn" placement="bottom" ngbTooltip="Beállítások" (click)="openSettings()">
                <span class="ficon font-medium-5 feather" [data-feather]="'settings'"></span>
            </a>
        </li>
        <!--/ Beállítások -->

        <div ngbDropdown [placement]="'bottom'" *ngIf="this.bizonylatok?.data.olvasas">
            <button ngbDropdownToggle type="button" class="btn nav-link nav-link-style" rippleEffect ngbTooltip="Bizonylatok">
                <span class="ficon font-medium-5 feather" [data-feather]="'grid'"></span>
            </button>
            <div ngbDropdownMenu>
                <a ngbdropdownitem="" class="dropdown-item ng-star-inserted" [routerLink]="['/', 'torzsek', 'ajanlat']" *ngIf="this.ajanlat?.data.olvasas"><span class="ficon font-medium-5 feather"
                        [data-feather]="'file-text'"></span> Árajánlat </a>
                <a ngbdropdownitem="" class="dropdown-item ng-star-inserted" [routerLink]="['/', 'torzsek', 'szallitolevel']" *ngIf="this.szallito?.data.olvasas"><span class="ficon font-medium-5 feather"
                        [data-feather]="'file-text'"></span> Szállítólevél </a>
                <a ngbdropdownitem="" class="dropdown-item ng-star-inserted" [routerLink]="['/', 'torzsek', 'kimeno-szamla']" *ngIf="this.kimeno?.data.olvasas"><span class="ficon font-medium-5 feather"
                        [data-feather]="'file-text'"></span> Kimenő számla </a>
                <a ngbdropdownitem="" class="dropdown-item ng-star-inserted" [routerLink]="['/', 'torzsek', 'nyugta']" *ngIf="this.nyugta?.data.olvasas"><span class="ficon font-medium-5 feather"
                        [data-feather]="'file-text'"></span> Nyugta </a>
            </div>
        </div>

        <!-- Support -->
        <li class="nav-item d-none d-lg-inline-flex" *ngIf="!currentUser?.munkatars">
            <a class="nav-link nav-link-style btn" placement="bottom" ngbTooltip="Support" style="position:relative" (click)="openSupport()">
                <span class="ficon font-medium-5 feather" [data-feather]="'users'"></span>
            </a>
        </li>
        <!--/ Support -->

        <!-- Munkatárs jelszo mod -->
        <li class="nav-item d-none d-inline-flex" *ngIf="currentUser?.munkatars">
            <a class="nav-link nav-link-style btn" placement="bottom" ngbTooltip="Jelszó módosítás" (click)="onJelszoMod(ujJelszo)">
                <span class="ficon font-medium-5 feather" [data-feather]="'settings'"></span>
            </a>
        </li>
        <!--/ Munkatárs jelszo mod -->
    </div>

    <ul class="nav navbar-nav align-items-center ml-auto">
        <div *ngIf="currentUser?.munkatars && !isMobile" class="nav-item mr-2">
            <ng-select style="width: 350px !important;" [items]="jogviszonyok | filterByCegNavbar : user?.oe" name="selectlabel" [clearable]="false" class="w-100" [(ngModel)]="selectedJogviszony" (change)="onJogviszonyChange($event)">
                <ng-template ng-label-tmp let-item="item">
                    <small>{{ item.jogviszony }}</small>
                </ng-template>
                <ng-template ng-value-tmp let-item="item">
                    <small>{{ item.jogviszony }}</small>
                </ng-template>
                <ng-template ng-option-tmp let-item="item">
                    <span>{{ item.jogviszony }}</span><br />
                </ng-template>
            </ng-select>
        </div>

        <ng-select *ngIf="(currentUser?.munkatars ? currentUser.felhasznalok?.length : true) && !isMobile" style="width: 400px !important;" class="oek" id="oe" [items]="oek$ | async" bindLabel="megnevezes" bindValue="id" [clearable]="false" [ngModel]="(currentUser$ | async)?.oe"
            [ngModelOptions]="{ standalone: true }" [required]="true" (change)="updateOnOeSelect($event)">
        </ng-select>
        <!-- User Dropdown -->
        <li ngbDropdown class="nav-item dropdown-user">
            <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" ngbDropdownToggle id="navbarUserDropdown" aria-haspopup="true" aria-expanded="false">
                <div class="user-nav d-sm-flex d-none">
                    <span class="user-name font-weight-bolder">{{
                        currentUser?.nev
                        }}</span><span class="user-status">{{currentUser?.oeNev}}</span>
                </div>
                <span class="avatar">
                    <img #avatar class="round"
                        src="{{currentUser?.avatar ? currentUser.avatar : '../../../assets/images/avatars/user.png'}}"
                        alt="avatar"
                        height="40" 
                        width="40" />
                    <span class="avatar-status-online"></span>
                </span>
            </a>
            <div ngbDropdownMenu aria-labelledby="navbarUserDropdown" class="dropdown-menu dropdown-menu-right">
                <ng-select *ngIf="(currentUser?.munkatars ? currentUser.felhasznalok?.length : true) && isMobile" class="oek w-100" [appendTo]="'body'" style="width: 90% !important;  margin-left: 1.5rem !important" id="oe" [items]="oek$ | async" bindLabel="megnevezes"
                    bindValue="id" [clearable]="false" [ngModel]="(currentUser$ | async)?.oe" [ngModelOptions]="{ standalone: true }" [required]="true" (change)="updateOnOeSelect($event)">
                </ng-select> <br>


                <ng-select *ngIf="currentUser?.munkatars && isMobile" style="width: 90% !important; margin-left: 1.5rem !important" [appendTo]="'body'" [items]="jogviszonyok | filterByCegNavbar : user?.oe" name="selectlabel" [clearable]="false" class="w-100" [(ngModel)]="selectedJogviszony"
                    (change)="onJogviszonyChange($event)">
                    <ng-template ng-label-tmp let-item="item">
                        <small>{{ item.jogviszony }}</small>
                    </ng-template>
                    <ng-template ng-value-tmp let-item="item">
                        <small>{{ item.jogviszony }}</small>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <span>{{ item.jogviszony }}</span><br />
                    </ng-template>
                </ng-select>

                <a *ngIf="!currentUser?.munkatars" class="w-100" ngbDropdownItem [routerLink]="['/', 'torzsek', 'feladatok']">
                    <span [data-feather]="'check-square'" [class]="'mr-50'"></span> Feladatok
                </a>
                <a *ngIf="!currentUser?.munkatars" class="w-100" ngbDropdownItem [routerLink]="['/', 'torzsek', 'naptar']">
                    <span [data-feather]="'calendar'" [class]="'mr-50'"></span> Naptár
                </a>
                <div *ngIf="!currentUser?.munkatars" class="dropdown-divider"></div>
                <button *ngIf="!currentUser?.munkatars" class="w-100" ngbDropdownItem (click)="openSettings()">
                    <span [data-feather]="'settings'" [class]="'mr-50'"></span>
                    Beállítások
                </button>
                <div *ngIf="!currentUser?.munkatars" class="dropdown-divider"></div>
                <button class="w-100" ngbDropdownItem (click)="logout()">
                    <span [data-feather]="'power'" [class]="'mr-50'"></span> Kijelentkezés
                </button>
            </div>
        </li>
        <!--/ User Dropdown -->
    </ul>
</div>

<!-- Raklapkezelés modal -->
<ng-template #sugo let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Súgó</h4>
        <!-- <button type="button" class="btn" aria-label="Close" (click)="modal.dismiss('Cross click')">x</button> -->
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
    </div>
    <ngb-carousel [showNavigationIndicators]="false" [interval]="0" (slide)="onSlide($event)" [activeId]="activeIndex">
        <ng-container *ngFor="let e of [].constructor(51); let i = index">
            <ng-template ngbSlide [id]="(i+1)">
                <div class="carousel-img-wrapper">
                    <img [src]="'https://aranyi.ftech.hu/print/tutorial/' + (i+1) + '.jpg'" class="img-fluid" alt="Random first slide" />
                </div>
                <div class="carousel-caption"></div>
            </ng-template>
        </ng-container>
    </ngb-carousel>
</ng-template>

<!-- Fájl feltöltés modal -->
<ng-template #fajlfeltoltesModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Fájlok</h4>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    </div>

    <div class="modal-body fajlfeltoltes-modal">
        <div class="row">
            <!-- LEFT COLUMN -->
            <div class="col-12 col-md-6 mb-3">
                <div class="container3 mt-2" appDragnDrop (fileDropped)="onFileDropped($event)">
                    <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" />
                    <img src="../../../../../../../assets/images/dnd/upload.svg" width="30" alt="" />
                    <h2>Húzd ide</h2>
                    <h2>vagy</h2>
                    <label for="fileDropRef">Fájlok kiválasztása</label>
                </div>
            </div>

            <!-- RIGHT COLUMN -->
            <div class="col-12 col-md-6 mb-3">
                <div class="divider mr-0 mr-md-4">
                    <div class="divider-text">Új fájlok</div>
                </div>

                <div *ngIf="newFiles.length > 0" class="files-list mr-0 mr-md-4">
                    <div class="single-file" *ngFor="let file of newFiles; let i = index">
                        <img src="../../../../../../../assets/images/dnd/file.svg" height="35" alt="file" />
                        <div class="info pl-2">
                            <input type="text" name="name" [value]="leaveFajlKiterjesztes(file.name)" (keyup)="changeFileName($event.target.value, i)" />
                            <span>.{{ file.name.split('.').pop() }}</span>
                            <p class="size">{{ formatBytes(file?.size) }}</p>
                        </div>
                        <img src="../../../../../../../assets/images/dnd/trash-2.svg" class="delete" width="15" alt="delete" (click)="deleteNewFile(i)" />
                    </div>
                </div>

                <div *ngIf="newFiles.length <= 0" class="files-list mr-0 mr-md-4">
                    <div class="single-file">
                        <p class="size">Nincs kiválasztott fájl...</p>
                    </div>
                </div>

                <a class="uploadBtn text-white mt-2 d-block text-center" (click)="onUploadFiles()">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Feltöltés
                </a>
            </div>
        </div>

        <!-- ATTACHED FILES -->
        <div class="divider mt-3 ml-0 ml-md-4 mr-0 mr-md-4">
            <div class="divider-text">Csatolt fájlok</div>
        </div>

        <div class="files-list ml-0 ml-md-4 mr-0 mr-md-4">
            <div class="single-file" *ngFor="let file of files; let i = index">
                <img src="../../../../../../../assets/images/dnd/file.svg" height="35" alt="file" />
                <div class="info pl-2">
                    <h4 class="name" (click)="openFile(file)">{{ file?.nev || file?.name }}</h4>
                    <p class="size">{{ formatBytes(file?.meret || file?.size) }}</p>
                </div>

                <a class="delete" [href]="environment.apiUrl + file.utvonal" [download]="file.nev" target="_blank">
                    <img src="../../../../../../../assets/images/dnd/download.svg" width="20" alt="download" />
                </a>
                <img src="../../../../../../../assets/images/dnd/trash-2.svg" class="delete" width="20" alt="delete" (click)="deleteFile(i, file)" />
            </div>
        </div>
    </div>
</ng-template>

<!-- Új jelszó beállítás -->
<ng-template #ujJelszo let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Új jelszó beállítása</h4>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form class="auth-login-form mt-2" [formGroup]="jelszoForm">
            <div class="form-group">
                <label class="form-label" for="login-jelszo">Új jelszó</label>
                <div class="input-group input-group-merge form-password-toggle">
                    <input [type]="passwordTextType ? 'text' : 'password'" formControlName="jelszo" class="form-control form-control-merge" [ngClass]="{
                  'ng-invalid.ng-touched error': false
                }" placeholder="············" aria-describedby="login-jelszo" tabindex="2" (blur)="checkJelszo()" />
                    <div class="input-group-append">
                        <span class="input-group-text cursor-pointer"><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                    (click)="togglePasswordTextType()"
                  ></i
                ></span>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="form-label" for="login-jelszo">Jelszó mégegyszer</label>
                <div class="input-group input-group-merge form-password-toggle">
                    <input [type]="passwordTextType ? 'text' : 'password'" formControlName="jelszo_2" class="form-control form-control-merge" [ngClass]="{
                  'ng-invalid.ng-touched error': false
                }" placeholder="············" aria-describedby="login-jelszo" tabindex="2" />
                    <div class="input-group-append">
                        <span class="input-group-text cursor-pointer"><i
                    class="feather font-small-4"
                    [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }"
                    (click)="togglePasswordTextType()"
                  ></i
                ></span>
                    </div>
                </div>
            </div>
            <span *ngIf="jelszo_wrong" style="color: red;">A megadott azonosító már használatban van. Kérlek adj meg másik azonosítót</span>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" id="cancel-edit-btn" class="btn btn-primary" [disabled]="jelszoForm.get('jelszo').value == null || jelszoForm.get('jelszo').value !== jelszoForm.get('jelszo_2').value" (click)="onJelszoChange(modal)">Mentés</button>
        <button type="button" id="cancel-edit-btn" class="btn btn-secondary" (click)="modal.dismiss('Cross click');">Mégse</button>
    </div>
</ng-template>